import classNames from 'classnames';
import get from 'lodash/get';
import P from 'prop-types';
import {
  stringInputSpec,
  stringSelectSpec,
  repeatable,
} from '../../lib/editing-configs';
import styles from './filters.module.scss';
import FilterLink from './components/link';

const FiltersLayout = {
  oneLine: 'one-line',
};

const Filters = ({ layout, filters }) => {
  return (
    <div className={classNames(styles.wrapper, styles[`wrapper__${layout}`])}>
      <div className={classNames(styles.filters, styles[`filters__${layout}`])}>
        {filters
          ?.map((filter) => {
            switch (filter.type) {
              case 'link':
                return (
                  <FilterLink
                    queryParams={{}}
                    filter={filter}
                    key={filter.$unique_key}
                  />
                );
              default:
                return null;
            }
          })
          .filter(Boolean)}
      </div>
    </div>
  );
};

Filters.displayName = 'Filters';

Filters.propTypes = {
  layout: P.string,
  filters: P.arrayOf(
    P.shape({
      type: P.string,
      label: P.string,
      param: P.string,
      $unique_key: P.string,
    })
  ),
};
Filters.defaultProps = {
  filters: [],
  layout: FiltersLayout.oneLine,
};

Filters.getEditingConfig = (componentDocument) => {
  return [
    repeatable(
      'filters',
      'Filters',
      'Filter',
      (index) => {
        const type = get(
          componentDocument,
          `props.filters[${index}].type`,
          'button'
        );

        return [
          stringSelectSpec('type', 'Filter type', [
            { label: 'Unselected', value: '' },
            { label: 'Link', value: 'link' },
          ]),
          ...(type === 'link'
            ? [
                stringInputSpec('label', 'Label'),
                stringInputSpec('param', 'Param name', {
                  help: 'The way of handling the link. It will create `example.org?{paramName}={paramValue}`',
                }),
                stringInputSpec('paramValue', 'Param value'),
              ]
            : []),
        ].filter(Boolean);
      },
      {
        label: (value) => `${value.type}: ${value.label}`,
      }
    ),
  ].filter(Boolean);
};

export default Filters;
